/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { ResponseCookies } from "next/dist/compiled/@edge-runtime/cookies";
import { NextResponse } from "next/server";

import { createToken } from "../utils/csrf.utils";

export const middlewareCSRF = async (response: NextResponse): Promise<void> => {
	const cookies = new ResponseCookies(response.headers);

	cookies.set(process.env.EPIC_CSRF_TOKEN_COOKIE_NAME as string, await createToken(), {
		maxAge: 600,
		sameSite: "strict",
		httpOnly: true,
	});
};
